import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import 'react-image-gallery/styles/css/image-gallery.css';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';

const ImageGallery = loadable(() => import('react-image-gallery'));

const ImageGalleryTemplate = ({ items }) => {
  const { settings } = config;
  const renderItems = items.filter(
    (content) =>
      settings.imageObjects.includes(content['@type']) && content.image_field,
  );

  const imagesInfo = renderItems.map((item) => {
    return {
      original: `${flattenToAppURL(item['@id'])}/@@images/${item.image_field}/large`,
      thumbnail: `${flattenToAppURL(item['@id'])}/@@images/${item.image_field}/thumb`,
      description: (
        <>
          <div className="title">{item.title}</div>
          <div className="description">{item.description}</div>
          <div className="download">
            <a
              href={`${flattenToAppURL(item['@id'])}/@@images/${item.image_field}/huge`}
              download
            >
              download
            </a>
          </div>
          <div className="credits">{item.copyright_and_sources}</div>
        </>
      ),
    };
  });

  return (
    renderItems.length > 0 && (
      <ImageGallery items={imagesInfo} lazyLoad={true} />
    )
  );
};

ImageGalleryTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default ImageGalleryTemplate;
